import { extendTheme } from '@chakra-ui/react';
import * as components from './components';
import * as foundations from './foundations';
import { defaultColors } from './foundations/default-colors';
const config = {
    cssVarPrefix: 'keychaine'
};
export const theme = extendTheme({ ...foundations, colors: defaultColors, config, components: { ...components } });
